// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__uGWs+","button":"styles_button__nr6UZ","active":"styles_active__k7d9r"};